/* ─────────────────────────────────────────────────────────────
   BRZY — Global JS (deferred)
   ───────────────────────────────────────────────────────────── */

document.addEventListener('DOMContentLoaded', function () {

  // ── Announcement bar dismiss ──────────────────────────────
  var annDismiss = document.querySelector('.ann-bar__dismiss');
  if (annDismiss) {
    annDismiss.addEventListener('click', function () {
      var bar = document.getElementById('ann-bar');
      if (bar) bar.style.display = 'none';
    });
  }

  // ── Nav: transparent over hero, frosted when past it ─────
  var nav    = document.getElementById('nav');
  var hero   = document.getElementById('brzy-hero');
  var header = document.getElementById('site-header');

  if (nav && hero) {
    function updateNav() {
      var pastHero = hero.getBoundingClientRect().bottom < 80;
      nav.classList.toggle('scrolled', pastHero);
      if (header) header.classList.toggle('hero-visible', !pastHero);
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  // ── Cart count (live) ─────────────────────────────────────
  brzyUpdateCartCount();

  // ── Search drawer ─────────────────────────────────────────
  brzyInitSearch();

  // ── Mobile menu drawer ────────────────────────────────────
  brzyInitMobileMenu();

  // ── Product page: gallery + variants ─────────────────────
  brzyInitProductGallery();
  brzyInitVariants();

});

/* ── Cart ───────────────────────────────────────────────────── */

function brzyUpdateCartCount() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.nav-cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    })
    .catch(function () {});
}

// Quick-add — called from product card ATC buttons
function brzyAddToCart(variantId, btn) {
  if (!variantId) return;
  var orig = btn.textContent;
  btn.textContent = 'Adding\u2026';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(function (r) {
      if (!r.ok) throw new Error('cart error');
      btn.textContent = 'Added';
      brzyUpdateCartCount();
    })
    .catch(function () {
      btn.textContent = 'Unavailable';
    })
    .finally(function () {
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 1500);
    });
}

/* ── Predictive Search ──────────────────────────────────────── */

function brzyInitSearch() {
  var openBtn    = document.getElementById('search-open-btn');
  var closeBtn   = document.getElementById('search-close-btn');
  var backdrop   = document.getElementById('search-backdrop');
  var drawer     = document.getElementById('search-drawer');
  var input      = document.getElementById('search-input');
  var results    = document.getElementById('search-results');
  var searchTimer;

  if (!drawer || !input) return;

  function openSearch() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    // Slight delay so CSS transition is visible before focus steals layout
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    clearTimeout(searchTimer);
    results.innerHTML = '';
    input.value = '';
  }

  if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  if (closeBtn) closeBtn.addEventListener('click', closeSearch);
  if (backdrop) backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  // Debounced predictive search
  input.addEventListener('input', function () {
    clearTimeout(searchTimer);
    var q = input.value.trim();

    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }

    searchTimer = setTimeout(function () {
      brzyFetchResults(q, results);
    }, 220);
  });
}

function brzyFetchResults(q, resultsEl) {
  var url = '/search/suggest.json'
    + '?q=' + encodeURIComponent(q)
    + '&resources[type]=product'
    + '&resources[limit]=6';

  fetch(url)
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (products.length === 0) {
        resultsEl.innerHTML = '<p class="search-no-results">No results for &ldquo;' + brzyEscape(q) + '&rdquo;</p>';
        return;
      }

      resultsEl.innerHTML = products.map(function (p) {
        var imgHtml = '';
        if (p.featured_image && p.featured_image.url) {
          // Shopify CDN image — append width param for a small thumbnail
          var thumbUrl = p.featured_image.url.split('?')[0] + '?width=120';
          imgHtml = '<img class="search-result-img" src="' + thumbUrl + '" alt="' + brzyEscape(p.title) + '" loading="lazy">';
        } else {
          imgHtml = '<div class="search-result-img"></div>';
        }

        // Predictive Search API returns price as a decimal string (e.g. "97.00"), not cents
        var priceStr = '';
        if (p.price) {
          var priceNum = parseFloat(p.price);
          priceStr = '$' + (priceNum % 1 === 0 ? priceNum.toFixed(0) : priceNum.toFixed(2));
        }

        return '<a href="' + p.url + '" class="search-result-item">'
          + imgHtml
          + '<div>'
          + '<p class="search-result-name">' + brzyEscape(p.title) + '</p>'
          + (priceStr ? '<p class="search-result-price">' + priceStr + '</p>' : '')
          + '</div>'
          + '</a>';
      }).join('');
    })
    .catch(function () {
      resultsEl.innerHTML = '';
    });
}

// Minimal XSS guard for injected strings
function brzyEscape(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/* ── Mobile Menu ────────────────────────────────────────────── */

function brzyInitMobileMenu() {
  var btn      = document.getElementById('mobile-menu-btn');
  var drawer   = document.getElementById('mobile-drawer');
  var closeBtn = document.getElementById('mobile-menu-close');

  if (!btn || !drawer) return;

  function openMenu() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    btn.setAttribute('aria-expanded', 'true');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
  }

  btn.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeMenu();
  });
}

/* ── Product Gallery ────────────────────────────────────────── */

function brzyInitProductGallery() {
  var thumbs      = document.querySelectorAll('.brzy-product__thumb');
  var featuredImg = document.getElementById('ProductFeaturedImage');

  if (!thumbs.length || !featuredImg) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      this.classList.add('is-active');
      if (this.dataset.imgUrl) {
        // Clear srcset first — Shopify's image_tag generates srcset which takes
        // precedence over src; without clearing it the image won't change.
        featuredImg.srcset = '';
        featuredImg.src = this.dataset.imgUrl;
        featuredImg.alt = this.dataset.imgAlt || '';
      }
    });
  });
}

/* ── Product Variant Picker ─────────────────────────────────── */

function brzyInitVariants() {
  var form = document.getElementById('product-form');
  if (!form) return;

  // Variant data embedded by brzy-product.liquid as window.__brzyVariants
  var variantData = window.__brzyVariants;
  if (!variantData || !variantData.length) return;

  var variantIdInput = document.getElementById('product-variant-id');
  var priceEl        = document.getElementById('product-price');
  var atcBtn         = document.getElementById('product-atc-btn');
  var featuredImg    = document.getElementById('ProductFeaturedImage');

  // Track current option selections — initialise from .is-selected buttons
  var selectedOptions = [];
  document.querySelectorAll('.brzy-product__option').forEach(function (optionEl, i) {
    var active = optionEl.querySelector('.brzy-product__variant-btn.is-selected');
    selectedOptions[i] = active ? active.dataset.optionValue : '';
  });

  document.querySelectorAll('.brzy-product__variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(this.dataset.optionIndex, 10);
      var val = this.dataset.optionValue;
      selectedOptions[idx] = val;

      // Update active state within this option group
      this.closest('.brzy-product__option-values')
        .querySelectorAll('.brzy-product__variant-btn')
        .forEach(function (b) {
          b.classList.toggle('is-selected', b.dataset.optionValue === val);
        });

      // Find the matching variant
      var match = null;
      for (var i = 0; i < variantData.length; i++) {
        var v = variantData[i];
        var allMatch = v.options.every(function (opt, oi) {
          return selectedOptions[oi] === opt;
        });
        if (allMatch) { match = v; break; }
      }

      if (!match) return;

      if (variantIdInput) variantIdInput.value = match.id;

      if (priceEl) priceEl.textContent = brzyFormatMoney(match.price);

      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available ? 'ADD TO CART' : 'SOLD OUT';
      }

      if (featuredImg && match.featured_image && match.featured_image.src) {
        var src = match.featured_image.src.split('?')[0];
        featuredImg.src = src + '?width=1000';
        featuredImg.alt = match.featured_image.alt || '';
      }
    });
  });
}

function brzyFormatMoney(cents) {
  var dollars = cents / 100;
  return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2))
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
